import React, { Component } from 'react';
import { Button, Modal, Card } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import paginationFactory, { PaginationProvider, PaginationListStandalone, SizePerPageDropdownStandalone } from 'react-bootstrap-table2-paginator';
import { Fetcher } from "../../../Helpers/fetcher.js";
import { Notify } from "../../../Helpers/notification.js";
import Dropdown from 'react-bootstrap/Dropdown';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import Cookies from 'js-cookie';

import "./index.css";

class ListWebhooks extends Component {
    constructor(props) {
        super(props);
        this.state = {
            blacklist: [],
            confirmDelete: false,
            selectedBlId: 0,
            webhookList: [],
            selectedWebhookId: 0,
            sizePerPage: 10,
            viewModal: false,
            viewContent: null,
            viewTitle: '',
            isJson: true
        }
    }

    componentDidMount() {
        this.getWebhooklist();
        const savedSizePerPage = Cookies.get('webhookListsizePerPage');
        if (savedSizePerPage) {
            this.setState({ sizePerPage: Number(savedSizePerPage) });
        }
    }

    getWebhooklist = () => {
        const apiPath = this.props.app.apiPath;
        const userId = this.props.app.userId;
        Fetcher.get(apiPath + '/api/obd/sms/webhooks/' + userId)
            .then(res => {
                this.setState({
                    webhookList: res,
                    confirmDelete: false,
                })
            })
            .catch(err => { console.log('Error in fetching sms webhooks', err) });
    }

    confirmDelete = (status, blId) => {
        this.setState({
            confirmDelete: status,
            selectedWebhookId: blId
        });
    }

    deleteWebhook = () => {
        const wId = this.state.selectedWebhookId;
        const data = {}

        return Fetcher.post(this.props.app.apiPath + '/api/obd/sms/webhooks/' + wId, { headers: { "Content-type": "application/json" }, method: 'DELETE', body: JSON.stringify(data) })
            .then(res => {
                Notify.notify(res.message);
                this.getWebhooklist();
            })
            .catch(err => {
                console.log('Error in Deleting sms Webhook', err);
            });
    }

    handleSizePerPageChange = (newSizePerPage) => {
        this.setState({ sizePerPage: newSizePerPage });
        Cookies.set('webhookListsizePerPage', newSizePerPage);
    }

    openViewModal = (content, title, isJson = true) => {
        this.setState({
            viewModal: true,
            viewContent: content,
            viewTitle: title,
            isJson: isJson
        });
    }

    closeViewModal = () => {
        this.setState({
            viewModal: false,
            viewContent: null,
            viewTitle: '',
            isJson: true
        });
    }

    formatJson = (jsonString) => {
        try {
            const parsed = JSON.parse(jsonString);
            return JSON.stringify(parsed, null, 2);
        } catch (e) {
            return jsonString; // Return as is if not valid JSON
        }
    }

    render() {
        const webhookList = this.state.webhookList;
        let columns = '';

        columns = [
            {
                dataField: 'id',
                text: 'Webhook Id',
                sort: true,
                hidden: false
            },
            {
                dataField: 'webhookName',
                text: 'Webhook Name',
                sort: false,
                searchable: true
            },
            {
                dataField: 'header',
                text: 'Header',
                sort: false,
                formatter: (cellContent, row) => {
                    if (!cellContent) return '';
                    return (
                        <Button 
                            variant="link" 
                            className="p-0" 
                            onClick={() => this.openViewModal(cellContent, 'Header', true)}
                        >
                            View Header
                        </Button>
                    );
                }
            },
            {
                dataField: 'url',
                text: 'Webhook Url',
                sort: true,
                searchable: true,
                formatter: (cellContent, row) => {
                    if (!cellContent) return '';
                    return (
                        <div>
                            <Button 
                                variant="link" 
                                className="p-0" 
                                onClick={() => this.openViewModal(cellContent, 'Webhook URL', false)}
                            >
                                View URL
                            </Button>
                        </div>
                    );
                }
            },
            {
                dataField: 'payload',
                text: 'Payload',
                sort: false,
                formatter: (cellContent, row) => {
                    if (!cellContent) return '';
                    return (
                        <Button 
                            variant="link" 
                            className="p-0" 
                            onClick={() => this.openViewModal(cellContent, 'Payload', true)}
                        >
                            View Payload
                        </Button>
                    );
                }
            },
            {
                dataField: 'requestType',
                text: 'Request Type',
                sort: true,
                searchable: true
            },
            {
                dataField: 'requestDate',
                text: 'Request Date',
                sort: true,
                searchable: true
            },
            {
                dataField: 'action',
                text: 'Action',
                sort: false,
                searchable: false
            }];

        const webhooks = Array.isArray(webhookList) ? webhookList.map((blist, index) => {
            let action = [];
            action.push(<Dropdown>
                <Dropdown.Toggle className='btn-sm'>Take Action</Dropdown.Toggle>
                <Dropdown.Menu>
                    <Dropdown.Item key={`${index}-edit-webhooks`} href={`${this.props.app.urlPrefix}/update-sms-webhooks/${blist.id}`}>Edit Webhooks</Dropdown.Item>
                    <Dropdown.Item key={`${index}-delete-webhooks`} onClick={(e) => { this.confirmDelete(true, blist.id) }} href="#">Delete Webhooks</Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>);
            return {
                id: blist.id,
                webhookName: blist.webhookName,
                url: blist.url,
                smsText: blist.smsText,
                payload: blist.payload,
                requestType: blist.requestType,
                requestDate: blist.timestamp,
                header: blist.header,
                action: action
            };
        }) : []

        const { SearchBar, ClearSearchButton } = Search;

        const defaultSorted = [{
            dataField: 'id',
            order: 'desc'
        }];

        const paginationOption = {
            custom: true,
            totalSize: webhooks.length,
            sizePerPage: this.state.sizePerPage,
            sizePerPageList: [10, 25, 50, 100],
            onSizePerPageChange: this.handleSizePerPageChange
        };

        return (
            <Card>
                <Card.Header>Sms Webhook List</Card.Header>
                <Card.Body>
                    <div className="campaign-list-table-cont">
                        {<PaginationProvider pagination={paginationFactory(paginationOption)}>
                            {
                                ({
                                    paginationProps,
                                    paginationTableProps
                                }) => (<ToolkitProvider keyField="webhookId" data={webhooks} columns={columns} search bootstrap4>
                                    {props => (<div className="">
                                        Show <SizePerPageDropdownStandalone className="search-dropdown" {...paginationProps} /> items
                                        <span className="search-cont"><SearchBar {...props.searchProps} /></span>
                                        <ClearSearchButton className="btn-primary" {...props.searchProps} />
                                        <hr />
                                        <BootstrapTable bordered={true} hover condensed defaultSorted={defaultSorted} wrapperClasses="table-responsive" classes="blacklist-table" {...props.baseProps} {...paginationTableProps} noDataIndication={() => (<div>{'No data available'}</div>)} />
                                        <PaginationListStandalone {...paginationProps} />
                                    </div>)}
                                </ToolkitProvider>)
                            }
                        </PaginationProvider>}
                    </div>

                    {/* Delete Confirmation Modal */}
                    <Modal size="md" show={this.state.confirmDelete} onHide={() => this.confirmDelete(false, '')}>
                        <Modal.Header closeButton>
                            <Modal.Title id="example-modal-sizes-title-sm">
                                Delete Webhook
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            Are you sure you want to delete this Webhook?
                        </Modal.Body>
                        <Modal.Footer>
                            <Button onClick={() => this.confirmDelete(false, '')} variant="secondary">CANCEL</Button>
                            <Button onClick={this.deleteWebhook} variant="primary">YES</Button>
                        </Modal.Footer>
                    </Modal>

                    {/* View Content Modal */}
                    <Modal size="sm" show={this.state.viewModal} onHide={this.closeViewModal} dialogClassName="custom-view-modal">
                        <Modal.Header closeButton>
                            <Modal.Title>{this.state.viewTitle}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body >
							<div className="modal-content-container">
								{this.state.viewContent && (
									this.state.isJson ? (
										<pre className="json-content">{this.formatJson(this.state.viewContent)}</pre>
									) : (
										<div className="url-content">
											{this.state.viewContent}
										</div>
									)
								)}
							</div>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button onClick={this.closeViewModal} variant="secondary">Close</Button>
                        </Modal.Footer>
                    </Modal>
                </Card.Body>
            </Card>
        );
    }
}

export default ListWebhooks;